import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

export default function CosmeticFillings() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const dir = currentLang === "ar" ? "rtl" : "ltr";
  const align = currentLang === "ar" ? "text-end" : "text-start";

  return (
    <div className="container py-5 mt-5" dir={dir}>
      <Helmet>
        <link
          rel="canonical"
          href="https://saleemsmile.com/articles/cosmetic-fillings"
        />

        <title>{t("cosmeticFillings.seo.title")}</title>
        <meta
          name="description"
          content={t("cosmeticFillings.seo.description")}
        />
        <meta name="keywords" content={t("cosmeticFillings.seo.keywords")} />
        <meta property="og:title" content={t("cosmeticFillings.seo.ogTitle")} />
        <meta
          property="og:description"
          content={t("cosmeticFillings.seo.ogDescription")}
        />
      </Helmet>

      <header className="text-center mb-5">
        <h1 className="fw-bold" style={{ color: "#00b3ff" }}>
          {t("cosmeticFillings.page.title")}
        </h1>
        <h5 className="text-muted">{t("cosmeticFillings.page.subtitle")}</h5>
        <p className="mt-3">{t("cosmeticFillings.page.author")}</p>
        <p className="small text-secondary">
          {t("cosmeticFillings.page.clinic")}
        </p>
      </header>

      <section className="mb-5">
        <h2 className={align}>{t("cosmeticFillings.page.whatIsTitle")}</h2>
        <p className={align}>{t("cosmeticFillings.page.whatIsText1")}</p>
        <p className={align}>{t("cosmeticFillings.page.whatIsText2")}</p>
      </section>

      <section className="mb-5">
        <h2 className={align}>{t("cosmeticFillings.page.whenTitle")}</h2>
        <ul className={align}>
          {t("cosmeticFillings.page.whenList", { returnObjects: true }).map(
            (item, i) => (
              <li key={i}>{item}</li>
            )
          )}
        </ul>
      </section>

      <section className="mb-5">
        <h2 className={align}>{t("cosmeticFillings.page.typesTitle")}</h2>

        <h4 className={align}>
          {t("cosmeticFillings.page.types.composite.title")}
        </h4>
        <ul className={align}>
          {t("cosmeticFillings.page.types.composite.list", {
            returnObjects: true,
          }).map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>

        <h4 className={align}>
          {t("cosmeticFillings.page.types.inlays.title")}
        </h4>
        <ul className={align}>
          {t("cosmeticFillings.page.types.inlays.list", {
            returnObjects: true,
          }).map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>

        <h4 className={align}>
          {t("cosmeticFillings.page.types.glass.title")}
        </h4>
        <ul className={align}>
          {t("cosmeticFillings.page.types.glass.list", {
            returnObjects: true,
          }).map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="mb-5">
        <h2 className={align}>{t("cosmeticFillings.page.advantagesTitle")}</h2>
        <ul className={align}>
          {t("cosmeticFillings.page.advantagesList", {
            returnObjects: true,
          }).map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="mb-5">
        <h2 className={align}>{t("cosmeticFillings.page.careTitle")}</h2>
        <ul className={align}>
          {t("cosmeticFillings.page.careList", { returnObjects: true }).map(
            (item, i) => (
              <li key={i}>{item}</li>
            )
          )}
        </ul>
      </section>

      <section className="mb-5">
        <h2 className={align}>{t("cosmeticFillings.page.messageTitle")}</h2>
        <blockquote className="fst-italic border-start ps-3">
          {t("cosmeticFillings.page.messageQuote")}
        </blockquote>
      </section>

      <div>
        <a href="/services" className="btn btn-outline-secondary">
          {t("cosmeticFillings.page.backButton")}
        </a>
      </div>
    </div>
  );
}
